module.exports = __webpack_public_path__ + "img/jdoodle-dark.2439c172.png";